<template>
  <v-form ref="form" v-model="valid" @input="$emit('valid', $event)">
    <v-row>
      <v-col cols="12">
        <v-combobox
          v-model="form.services"
          name="services"
          item-value="id"
          item-text="title"
          :items="servicesList"
          :readonly="readonly"
          :label="$t('EMPLOYEES.PROVIDED_SERVICES')"
          :error-messages="errors.service_ids"
          multiple
          chips
          @change="updateValue('services', $event)"
        ></v-combobox>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-combobox
          v-model="form.building_complexes"
          name="building_complexes"
          item-value="id"
          item-text="name"
          :items="buildingComplexesList"
          :readonly="readonly"
          :label="$t('EMPLOYEES.LOCALITY_BUILDING_COMPLEXES')"
          :error-messages="errors.building_complex_ids"
          multiple
          chips
          @change="updateValue('building_complexes', $event)"
        ></v-combobox>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-combobox
          v-model="form.regions"
          name="regions"
          item-value="id"
          item-text="name"
          :items="regionsList"
          :readonly="readonly"
          :label="$t('REGIONS.ITEMS')"
          :error-messages="errors.region_ids"
          multiple
          chips
          @change="updateValue('regions', $event)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-combobox
          v-model="form.skills"
          name="skills"
          item-value="id"
          item-text="name"
          :items="skillsList"
          :readonly="readonly"
          :label="$t('EMPLOYEES.SKILLS')"
          :error-messages="errors.skill_ids"
          multiple
          chips
          @change="updateValue('skills', $event)"
        ></v-combobox>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { mapActions } from 'vuex';
import { mapCacheActions } from 'vuex-cache';
import formEditable from '@/modules/_global/mixins/form-editable';

export default {
  name: 'EmployeeAdditionalInformationForm',

  mixins: [formEditable],

  data() {
    return {
      valid: false,
      form: {
        services: [],
        building_complexes: [],
        regions: [],
        skills: []
      },
      servicesList: [],
      buildingComplexesList: [],
      regionsList: [],
      skillsList: []
    };
  },

  mounted() {
    this.setData();
    this.unwatch = this.$store.watch(
      state => state.localization.lang,
      () => {
        const lang = this.$store.state.localization.lang;

        if (lang) {
          this.setData();
        }
      }
    );
  },

  methods: {
    ...mapActions('service', ['retrieveEmployeeServices']),
    ...mapActions('building_complex', ['retrieveBuildingComplexesList']),
    ...mapCacheActions('region', ['retrieveRegions']),
    ...mapCacheActions('employee', ['getEmployeeSkills']),
    setData() {
      this.retrieveEmployeeServices().then(({ data }) => {
        this.servicesList = data.data;
      });

      this.retrieveBuildingComplexesList().then(({ data }) => {
        this.buildingComplexesList = data.data;
      });

      this.retrieveRegions().then(({ data }) => {
        this.regionsList = data.data;
      });

      this.getEmployeeSkills().then(({ data }) => {
        this.skillsList = data.data;
      });
    }
  }
};
</script>
